import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// Suppress ResizeObserver loop error - this is a benign error that occurs
// with dynamic layouts and doesn't affect functionality
const resizeObserverErrMsg = 'ResizeObserver loop';

// Suppress in window.onerror
const originalOnError = window.onerror;
window.onerror = function(message, source, lineno, colno, error) {
  if (message && message.toString().includes(resizeObserverErrMsg)) {
    return true;
  }
  return originalOnError ? originalOnError(message, source, lineno, colno, error) : false;
};

// Suppress in error event listener
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes(resizeObserverErrMsg)) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
    return true;
  }
}, true);

// Suppress in unhandledrejection for any promise-based errors
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message && e.reason.message.includes(resizeObserverErrMsg)) {
    e.preventDefault();
    return true;
  }
});

// Override ResizeObserver to prevent the error from being thrown
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      // Use requestAnimationFrame to batch notifications
      window.requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (e) {
          // Silently ignore ResizeObserver errors
        }
      });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
